export const en: Record<string, string> = {
  'rides.filters.search': 'Search rides',
  'rides.filters.community': 'Community',
  'rides.filters.allCommunities': 'All communities',
  'rides.filters.communityHint': 'Driver or passenger with a current community membership.',
  'rides.filters.communityError': 'Could not load communities.',
  'rides.filters.user': 'User',
  'rides.filters.role': 'User role',
  'rides.filters.role.all': 'All involvement',
  'rides.filters.role.DRIVER': 'As driver',
  'rides.filters.role.RIDER': 'As passenger',
  'rides.filters.type': 'Ride type',
  'rides.filters.type.all': 'All rides',
  'rides.filters.type.RECURRING': 'Recurring rides',
  'rides.filters.type.SINGLE': 'Single rides',
  'rides.filters.period': 'Departure period',
  'rides.filters.period.all': 'All dates',
  'rides.filters.period.today': 'Today',
  'rides.filters.period.next7': 'Next 7 days',
  'rides.filters.period.last30': 'Last 30 days',
  'rides.filters.period.range': 'Custom range',
  'rides.filters.from': 'From',
  'rides.filters.to': 'Through',
  'rides.filters.zone': 'Departure dates in Europe/Vienna; end date is included.',
  'rides.filters.status': 'Status',
  'rides.filters.direction': 'Order',
  'rides.filters.direction.ASC': 'Earliest first',
  'rides.filters.direction.DESC': 'Latest first',
  'rides.filters.size': 'Rows',
  'rides.filters.active': 'Active filters',
  'rides.filters.remove': 'Remove filter: {label}',
  'rides.filters.invalidRange': 'Start date must be on or before the end date. Choose two valid dates.',
  'rides.filters.viewRides': 'View rides',
};

export const de: Record<string, string> = {
  'rides.filters.search': 'Fahrten suchen',
  'rides.filters.community': 'Community',
  'rides.filters.allCommunities': 'Alle Communities',
  'rides.filters.communityHint': 'Fahrer oder Mitfahrer mit aktueller Community-Mitgliedschaft.',
  'rides.filters.communityError': 'Communities konnten nicht geladen werden.',
  'rides.filters.user': 'Nutzer',
  'rides.filters.role': 'Nutzerrolle',
  'rides.filters.role.all': 'Alle Beteiligungen',
  'rides.filters.role.DRIVER': 'Als Fahrer',
  'rides.filters.role.RIDER': 'Als Mitfahrer',
  'rides.filters.type': 'Fahrttyp',
  'rides.filters.type.all': 'Alle Fahrten',
  'rides.filters.type.RECURRING': 'Serienfahrten',
  'rides.filters.type.SINGLE': 'Einzelfahrten',
  'rides.filters.period': 'Abfahrtszeitraum',
  'rides.filters.period.all': 'Alle Zeiträume',
  'rides.filters.period.today': 'Heute',
  'rides.filters.period.next7': 'Nächste 7 Tage',
  'rides.filters.period.last30': 'Letzte 30 Tage',
  'rides.filters.period.range': 'Eigener Zeitraum',
  'rides.filters.from': 'Von',
  'rides.filters.to': 'Bis einschließlich',
  'rides.filters.zone': 'Abfahrtsdaten in Europe/Vienna; der letzte Tag wird mitgezählt.',
  'rides.filters.status': 'Status',
  'rides.filters.direction': 'Reihenfolge',
  'rides.filters.direction.ASC': 'Früheste zuerst',
  'rides.filters.direction.DESC': 'Neueste zuerst',
  'rides.filters.size': 'Zeilen',
  'rides.filters.active': 'Aktive Filter',
  'rides.filters.remove': 'Filter entfernen: {label}',
  'rides.filters.invalidRange': 'Das Startdatum muss vor oder am Enddatum liegen. Bitte zwei gültige Daten auswählen.',
  'rides.filters.viewRides': 'Fahrten ansehen',
};
